import { Controller } from "@hotwired/stimulus"

// Full screen for Signals' chart cards: every card with a chart or table
// gets the expand icon the messenger pane uses, in its head; it fills the
// screen until the icon or Escape closes it.
const CHART = ".signal-sales-mix, .sig-wins, .signal-line-chart, svg.sig-chart, .signal-insights-bars, .signal-diverging, .signal-dots, .signal-leaderboard-rows, table"

export default class extends Controller {
    connect() {
        this.element.querySelectorAll(".signal-insights-card").forEach((card) => {
            if (!card.querySelector(CHART) || card.querySelector(".signal-expand-btn")) return
            const head = card.querySelector(".signal-card-head")
            if (!head) return
            const button = document.createElement("button")
            button.type = "button"
            button.className = "signal-expand-btn"
            button.setAttribute("aria-label", "Full screen")
            button.setAttribute("aria-pressed", "false")
            button.title = "Full screen"
            button.innerHTML = '<i class="bi bi-arrows-angle-expand" aria-hidden="true"></i>'
            button.addEventListener("click", () => this.toggle(card, button))
            head.appendChild(button)
        })
        this.escape = (event) => { if (event.key === "Escape" && this.open) this.toggle(this.open.card, this.open.button) }
        document.addEventListener("keydown", this.escape)
    }

    disconnect() {
        document.removeEventListener("keydown", this.escape)
        document.body.classList.remove("signal-expanded")
    }

    toggle(card, button) {
        const expanding = !card.classList.contains("is-expanded")
        if (expanding && this.open) this.toggle(this.open.card, this.open.button)
        card.classList.toggle("is-expanded", expanding)
        document.body.classList.toggle("signal-expanded", expanding)
        button.setAttribute("aria-pressed", String(expanding))
        button.title = expanding ? "Exit full screen" : "Full screen"
        button.setAttribute("aria-label", button.title)
        button.querySelector("i").className = `bi ${expanding ? "bi-arrows-angle-contract" : "bi-arrows-angle-expand"}`
        this.open = expanding ? { card, button } : null
    }
}
